import { createSlice } from "@reduxjs/toolkit";

const initialNavBar = {
    isMenuBtnClicked: false,
    isSearchBtnClicked: false
};

const NavBarSlice = createSlice({
    name: "navbar",
    initialState: initialNavBar,
    reducers: {
        clickMenuBtn: (state,action) => {
            return {...state, isMenuBtnClicked: !state.isMenuBtnClicked}
        },
        clickSearchBtn: (state, action) => {
            return {...state, isSearchBtnClicked: !state.isSearchBtnClicked}
        }
   }
})

//Selector, export Selector
export const selectIsMenuBtnClicked = state => state.navBar.isMenuBtnClicked;
export const selectIsSearchBtnClicked = state => state.navBar.isSearchBtnClicked;

//Export Action Creators, Reducers from Slice
export const {clickMenuBtn, clickSearchBtn} = NavBarSlice.actions;
export default NavBarSlice.reducer;